import { render, staticRenderFns } from "./foodAnalysis.vue?vue&type=template&id=7d7f48ca&scoped=true"
import script from "./foodAnalysis.vue?vue&type=script&lang=js"
export * from "./foodAnalysis.vue?vue&type=script&lang=js"
import style0 from "./foodAnalysis.vue?vue&type=style&index=0&id=7d7f48ca&prod&scoped=true&lang=css"
import style1 from "./foodAnalysis.vue?vue&type=style&index=1&id=7d7f48ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7f48ca",
  null
  
)

export default component.exports